import { render, staticRenderFns } from "./PurchaseOrderHistory.vue?vue&type=template&id=47dd998a&scoped=true"
import script from "./PurchaseOrderHistory.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dd998a",
  null
  
)

export default component.exports